import { atom } from "jotai";

import { ActivateAccountStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToActivateAccountStepAtom = atom(
  null,
  (
    get,
    set,
    {
      email,
    }: {
      email: string;
    }
  ) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: ActivateAccountStep = {
      step: "ActivateAccount",
      backStep: "AccountNotFound",
      email,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.ActivateAccountStep", nextStep);
  }
);
